var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89366",
    "data-name": "Group 89366",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M91.5,0A91.076,91.076,0,0,0,37.8,17.411L0,0,17.411,37.8a91.514,91.514,0,0,0,19.444,127.1c-2.245-5.126-5.715-13.05-5.715-13.05a3.931,3.931,0,0,1,1.905-5.3,4.064,4.064,0,0,1,5.393,1.976l-1.852-4.229a4.151,4.151,0,0,1,7.6-3.327l-1.7-3.874a4.151,4.151,0,0,1,7.6-3.329l-7.638-19.069c-.878-2.013-.544-4.275,1.555-5.194s3.993.207,4.871,2.22c0,0,16.481,33.313,19.887,41.08,3.345,7.646.346,13.443,6.908,28.841A92.547,92.547,0,0,0,91.5,183q4.186,0,8.284-.371c2.174-3.071,12.843-19.8.9-37.544-2.423-3.6-2.9-2.108-11.333-.465s-11.534.889-14.655-4.385c-2.234-3.775-.315-7.108-2.1-9.4-1.609-2.059-5.483-.675-6.476-.716s-2.434-2.134-1.173-4.233c.847-1.4,3.678-2.212-.45-2.531-1.627-.124-2.941-1.158-2.708-2.588.315-1.942,1.863-2.119,3.945-4.928,1.343-1.812.533-4.035-2.6-3.918-1.208.046-4.762.172-6.506-1.612-3.342-3.42,9-15.312,9.543-21.761.19-2.266-.19-3.552-1.954-8.4C62.193,74.6,63.862,62.419,67.7,53.716S91.118,11.61,135.671,28.034c34.054,12.552,30.982,53.4,24.8,63.2S150,108.2,151.465,121.108s4.321,20.472,7.657,24.4a32.266,32.266,0,0,0,3.667,3.36A91.506,91.506,0,0,0,91.5,0Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilent);
export default __webpack_public_path__ + "static/media/silent.c43b2b8445048878b22e88b099248ec9.svg";
export { ForwardRef as ReactComponent };